<div class="curtain">

<section class="component-modalDialog redesigned">
    <div class="contentContainer">
        <div class="component-loadingBox">
            <div class="spinner"></div>
            <p>{{ text }}</p>
        </div>
    </div>
</section>

</div><!-- curtain -->